// TODO: ユーザストレージ、セッションストレージの共通処理はこのファイルに集約する
import { getUserStorage } from 'components/features/utils/utils';
import { State } from 'hooks/useRouting';

// user
export const updateRegisteredWebPush = (isRegisteredWebPush: boolean): void => {
  const user = getUserStorage();
  if (user) {
    user.RegisteredWebPush = isRegisteredWebPush;
    sessionStorage.setItem('user', JSON.stringify(user));
  }
};

type ViewedWebPush = {
  dailyReport: boolean;
  securityAccounts: boolean;
};

// viewedWebPush
export const getViewedWebPushStorage = (): ViewedWebPush | null => {
  const userJson = sessionStorage.getItem('viewedWebPush');
  return userJson ? (JSON.parse(userJson) as ViewedWebPush) : null;
};

export const updateViewedWebPush = (
  dailyReport: boolean,
  securityAccounts: boolean
): void => {
  const storage = {
    dailyReport: dailyReport,
    securityAccounts: securityAccounts,
  };

  sessionStorage.setItem('viewedWebPush', JSON.stringify(storage));
};

export const updateViewedWebPushDailyReport = (dailyReport: boolean): void => {
  const viewedWebPush = getViewedWebPushStorage();

  if (viewedWebPush) {
    viewedWebPush.dailyReport = dailyReport;
    sessionStorage.setItem('viewedWebPush', JSON.stringify(viewedWebPush));
  }
};

export const updateViewedWebPushSecurityAccounts = (
  securityAccounts: boolean
): void => {
  const viewedWebPush = getViewedWebPushStorage();

  if (viewedWebPush) {
    viewedWebPush.securityAccounts = securityAccounts;
    sessionStorage.setItem('viewedWebPush', JSON.stringify(viewedWebPush));
  }
};

export type AssetFilterItemsProps = {
  report: boolean;
  economicIndicators: boolean;
  assetFormationGuide: boolean;
};

export const getNotificationSiteTypeStorage = (): AssetFilterItemsProps | null => {
  const userJson = localStorage.getItem('notificationSiteType');
  return userJson ? (JSON.parse(userJson) as AssetFilterItemsProps) : null;
};

export const updateNotificationSiteType = (
  report: boolean,
  economicIndicators: boolean,
  assetFormationGuide: boolean
): void => {
  const storage = {
    report: report,
    economicIndicators: economicIndicators,
    assetFormationGuide: assetFormationGuide,
  };

  localStorage.setItem('notificationSiteType', JSON.stringify(storage));
};

export type Scroll = {
  path: string;
  height: number;
};

// scroll
export const getScrollStorage = (): Scroll[] | null => {
  const userJson = sessionStorage.getItem('scroll');
  return userJson ? (JSON.parse(userJson) as Scroll[]) : null;
};

export const updateScrollStorage = (list: Scroll[]): void => {
  sessionStorage.setItem('scroll', JSON.stringify(list));
};

// routing
export const getRoutingStorage = (): State | null => {
  const userJson = sessionStorage.getItem('routing');
  return userJson ? (JSON.parse(userJson) as State) : null;
};

export const updateRoutingStorage = (state: State): void => {
  sessionStorage.setItem('routing', JSON.stringify(state));
};
